import { Button, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GET } from '../../../utils/requestActionConstants';
import { API_ROUTE } from '../../../utils/commonConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { addNotification, updateNotification } from '../../../store/slices/notificationSlice';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

function AddNotification({ onSwitchTab, tabProps = {} }) {
  const notification = useSelector(state => state.notificationSlice.notification);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    loadValues();
  }, [notification]);

  const loadValues = () => {
    if (notification.id) {
      form.setFieldsValue(notification);
    } else {
      form.resetFields();
    }
  }

  const saveNotification = (data) => {
    if (notification.id) {
      dispatch(updateNotification({ notificationId: notification.id, notificationData: data }));
    } else {
      dispatch(addNotification({ notificationData: data }));
    }
  }

  return (
    <div>
      <div className='text-center py-2 mb-10 mt-5 font-bold p-5 rounded-lg mx-auto w-fit text-xl '>{notification.id ? "Update notification" : "Add New notification"}</div>
      <Form
        form={form}
        layout='verticle'
        {...formItemLayout}
        style={{
          maxWidth: 600,
          margin: 'auto'
        }}
        onFinish={saveNotification}
      >
        <Form.Item
          label="Notification Title"
          name="title"
          rules={[
            {
              required: true,
              message: 'Enter notification title here',
            },
          ]}
        >
          <Input placeholder='Title of the notification' />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[
            {
              required: true,
              message: 'Enter notification description here',
            },
          ]}
        >
          <Input placeholder='Title of the description' />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[
            {
              required: true,
              message: 'Select Status',
            },
          ]}
        >
          <Select
            placeholder="Select Status"
          >
            <Select.Option value={'Active'}>{'Active'}</Select.Option>
            <Select.Option value={'Inactive'}>{'Inactive'}</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ sm: { offset: 6, span: 14 }, xs: { offset: 0, span: 14 } }}>
          <div className='flex justify-between'>
            <div>{notification.id ? <Button onClick={loadValues}>Revert Changes</Button> : <></>}</div>
            <div className='flex'>
              <Button danger type='text' htmlType='reset'>Clear</Button>
              <Button type='primary' htmlType='submit'>{notification.id ? "Update" : "Save"}</Button>
            </div>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}

export default AddNotification